module.exports = __webpack_public_path__ + "img/NIDM_Terms_Annotations_Figure2_9dcb88e013764959.be80aeb7.png";